import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import Rectangle from 'blocks.simple/rectangle/rectangle'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import styles from './instancesCatalog.jcss'
import helpers from 'core/helpers'
import translate from 'core/translate'
import { routes } from 'features/routes'
import { changeLocation } from 'features/routes'
import { connect } from 'react-redux'
import { checkAvailableModule } from '../../core/helpers/routes/routes'
import { api } from 'core/api/ConnectionManager'
import { INSTANCES_CATALOG_TYPE, InstancesCatalogItem } from './InstancesCatalog-types'

export type InstancesCatalogProps = {
    minimizeMenu: boolean
}

const getCatalogImage = (catalog: string) => {
    const catalogName = catalog.replace('Catalog', '')

    switch (catalogName) {
        case 'combo':
        case 'burgers':
        case 'smallBurgers':
        case 'snacks':
        case 'drinks':
            return `images/catalogs/${catalog}.png`
        default:
            return 'images/helpers/empty_grey.png'
    }
}

export const InstancesCatalogComponent = ({ minimizeMenu }: InstancesCatalogProps) => {
    const [catalogs, setCatalogs] = useState<InstancesCatalogItem[]>([])

    useEffect(() => {
        api.send('getInstancesCatalogList', {}).then((res) => {
            if (res) {
                setCatalogs(res as InstancesCatalogItem[])
            }
        })
    }, [])

    return (
        <Content title={translate(INSTANCES_CATALOG_TYPE)} wrapperClassName={styles.instancesWrapper}>
            <div className={styles.wrapper}>
                {catalogs.map((catalog, index) => {
                    if (!helpers.isAvailable({ key: catalog.action, action: 'create' })) {
                        return null
                    }

                    const image = getCatalogImage(catalog.name)

                    return (
                        <div
                            className={cn(styles.cellWrapper, minimizeMenu ? grid.col4 : grid.col3)}
                            key={`catalog_list_${index}`}
                        >
                            <div
                                onClick={() => {
                                    changeLocation(`/${routes[catalog.action].path}`)
                                }}
                            >
                                <Rectangle width={14} height={7} className={styles.imageWrapper}>
                                    <img alt={`${catalog.name}_logo`} src={image} />
                                </Rectangle>
                                <div className={styles.title}>{translate(catalog.name)}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </Content>
    )
}

const mapStateToProps = (state: { app: { minimizeMenu: boolean } }) => ({
    minimizeMenu: state.app.minimizeMenu,
})

export const InstancesCatalog = checkAvailableModule('instancesCatalog')
    ? connect(mapStateToProps)(InstancesCatalogComponent)
    : null
